import axios from "axios";

// Setting the base URL for API requests based on the environment variable
// If REACT_APP_API_URL is defined, use its value; otherwise, 
// fallback to "http://localhost:5000/api"
// const baseURL = process.env.REACT_APP_API_URL
//   ? process.env.REACT_APP_API_URL
//   : "http://localhost:5000/api";

const baseURL = "https://mydigitalcarehome.ca/api";

export default axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json",
  },
});
